module.exports = __webpack_public_path__ + "static/media/11.4908a430.ogg";